import i18next from 'i18next';

i18next.addResources('en', 'MaturationCaskTypeBreakdown', {
  caskTypeBreakdown: 'CASK TYPE BREAKDOWN'
});
